import React, { memo } from 'react'
import { SvgIcon } from '../../../../shared/ui/SvgIcon/SvgIcon'
import { faFileCsv } from '@fortawesome/free-solid-svg-icons/faFileCsv'
import Button from '@mui/material/Button'
import { exportDataToCsv } from '../../model/lib/exportDataToCsv'
import Tooltip from '@mui/material/Tooltip'
import { mapInstancesToExport } from '../../model/lib/mapInstancesToExport'
import {
	useAppSelector
} from '../../../../shared/lib/hooks/useAppSelector/useAppSelector'
import {
	selectAllInstancesIsLoading
} from '../../model/selectors/selectAllInstancesIsLoading'
import {
	useAppDispatch
} from '../../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { fetchInstancesAll } from '../../model/srevices/fetchInstancesAll'

interface InstancesExporterProps {
	columnNames: string[]
	licenseId: string
}

export const InstancesExporter = memo((props: InstancesExporterProps) => {
	const { columnNames, licenseId } = props
	const dispatch = useAppDispatch()
	const isLoading = useAppSelector(selectAllInstancesIsLoading)

	const handleExport = async () => {
		const result = await dispatch(fetchInstancesAll(licenseId))
		if (result.meta.requestStatus === 'fulfilled') {
			// @ts-ignore
			const instances = mapInstancesToExport(result.payload)
			exportDataToCsv(columnNames, instances)
		}
	}


	return (
		<Tooltip title={'Export full table data to csv'}>
			<Button
				color="info"
				size="small"
				disabled={isLoading}
				variant="contained"
				sx={{ height: '1.9rem' }}
				onClick={handleExport}
			>
				<SvgIcon icon={faFileCsv} /> &nbsp;
			</Button>
		</Tooltip>
	)
})